<template>
  <ul class="list">
    <li v-for="{title, subTitle, pos} in documents" :key="pos" class="list__item">
      <document-icon class="list__icon"/>
      <a
        :href="`/${path}/${subTitle}`"
        class="list__link"
        rel="noreferrer noopener"
        target="_blank">
        {{ title }}
      </a>
    </li>
  </ul>
</template>

<script>
import documentIcon from '~/static/img/icons/document.svg';

export default {
  name: 'DocumentsList',
  components: { documentIcon },
  props: {
    path: {
      type: String,
      default: 'documents',
    },
    documents: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.documents {
  &__title {
    font-weight: 600;
  }
}

.list {
  padding-left: 0;

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__icon {
    @include square(30px);
    flex-shrink: 0;
    margin-right: 10px;
  }

  &__link {
    color: #333;
  }
}
</style>
